import { render, staticRenderFns } from "./tuoiEstrattiConto.vue?vue&type=template&id=c0f3adb6&"
import script from "./tuoiEstrattiConto.vue.ts?vue&type=script&lang=js&"
export * from "./tuoiEstrattiConto.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports